export const cornOb = {
  text1: true,
  text2: true,
  text3: true,
  title: 'Corn/Maize',
  desc: [
    'Corn/maize, with a trade value in excess of $28bn, was the seventh-most traded food commodity in the world. Global corn exports reached 110 million tonnes in 2013, while the annual average price was estimated at $259.4 per tonne.',
    'Global corn production during the year exceeded 969 million tonnes, while consumption reached 936 million tonnes. The US produced more than 350 million tonnes of corn, becoming the biggest corn producer followed by China. The US was also the biggest corn consumer with the domestic corn consumption exceeding 290 million tonnes during 2013.',
    "The US exported more than 35 million tonnes of corn in 2013, becoming the biggest corn exporter followed by Brazil, Ukraine and Argentina, Japan, which imported more than 15 million tonnes of corn, was the world's biggest corn importer followed by Mexico, the EU and China",
  ],
}

export const wheatOb = {
  text1: true,
  text2: true,
  text3: true,
  title: 'Wheat',
  desc: [
    'Wheat was the third-biggest food commodity traded in the world. The estimated trade value of wheat in 2013 exceeded $45bn with the export volume reaching 154 million tonnes. The annual average price of the food grain during 2013 stood at $294 per tonne.',
    "World wheat production during 2013 was approximately 711 million tonnes, while the total consumption was estimated at 704 million tonnes. The EU, followed by China, is the biggest producer of wheat. China, which consumed approximately 125 million tonnes of wheat during 2013, was the world's biggest wheat consumer.",
    "The US was the largest exporter of wheat and associated wheat products, followed by the Eu. Egypt, which imported around 10 million tonnes in 2013, was the world's biggest wheat importer, followed by China, which imported 8.5 million tonnes.",
  ],
}

export const soybeansOb = {
  text1: true,
  text2: false,
  text3: false,
  title: 'Soybeans',
  desc: [
    'Soybean, with an estimated trade value of more than $58bn, was the second-most traded food commodity in the world. The export volume of the oilseed stood in excess of 108 million tonnes in 2013. The world annual average price of the commodity during the period was estimated at $538 per tonne.',
  ],
}

export const riceOb = {
  text1: true,
  text2: true,
  text3: true,
  title: 'Rice',
  desc: [
    'Rice, with an estimated trade value of more than $18bn, ranks ninth on the list of the biggest food commodities traded in the world market. The export volume of rice was 40 million tonnes in 2013, while the world annual average price of the commodity during 2013 was estimated at $461 per tonne',
    "World rice production was approximately 470 million tonnes in 2013, while total consumption was estimated at 472 million tonnes. China was the biggest rice producer and consumer in the world followed by India. China produced more than 141 million tonnes and consumed more than 145 million tonnes of rice in 2013. India's rice production and consumption during the year stood at 103 million tonnes and 95 million tonnes respectively.",
    "India, exporting more than 10 million tonnes of rice annually, continued to be the world's biggest rice exporter followed by Thailand and Vietnam. China, importing more than three million tonnes of rice annually, was the biggest rice importer after Nigeria and Iran.",
  ],
}
